module.exports = __webpack_public_path__ + "media/images/icon_map_placemark_active-3929acd1.svg";